import {Directive, ViewContainerRef} from '@angular/core';
export class SlideZoneDirective {
/**
 * @param {?} viewContainerRef
 */
constructor(public viewContainerRef: ViewContainerRef) {

    }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[slideZone]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function SlideZoneDirective_tsickle_Closure_declarations() {
/** @type {?} */
SlideZoneDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SlideZoneDirective.ctorParameters;
/** @type {?} */
SlideZoneDirective.prototype.viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
